import React from 'react';
import { ComboboxState } from './types';

export const ComboboxContext = React.createContext<ComboboxState | null>(null);
